"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LandingPageImageUploadModule = /** @class */ (function () {
    function LandingPageImageUploadModule() {
    }
    return LandingPageImageUploadModule;
}());
exports.LandingPageImageUploadModule = LandingPageImageUploadModule;
